$('#register-form').submit(function (e) {
    e.preventDefault();

    // get a handle

});